import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const preventWizardBackGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();
  
  // If the user tries to navigate to the wizard using the browser's Back or Forward button,
  // we block it and redirect them to the dashboard.
  if (navigation?.trigger === 'popstate') {
    return router.parseUrl('/dashboard');
  }
  
  return true;
};
